import { LoadboardListRequest, LoadboardRequest } from '@trukt/tms-api/LoadboardService';
import { createKey } from '../createKey';

export interface UnsyncedPostsParams {
  pg?: number;
  rc?: number;
}

export interface DuplicatesParams {
  id: string;
}

const keyHandler = createKey('loadboard');
const adminKeyHandler = createKey('loadboardAdmin');

export const LoadboardServiceKeys = {
  key: keyHandler.key,
  list: keyHandler.createMethod<LoadboardListRequest>(),
  getById: keyHandler.createMethod<LoadboardRequest>(),
};

export const LoadboardAdminServiceKeys = {
  key: adminKeyHandler.key,
  unsyncedPosts: adminKeyHandler.createMethod<UnsyncedPostsParams | void>(),
  duplicates: adminKeyHandler.createMethod<DuplicatesParams>(),
};
